var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSgyDth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,10.59v-2.59h-3v-2h3V0h-2V4H5V0H3V6h3v2H3v3l-.21-.21L0,13.59v4.41c0,2.21,1.79,4,4,4s4-1.79,4-4v2c0,2.21,1.79,4,4,4s4-1.79,4-4v-2c0,2.21,1.79,4,4,4s4-1.79,4-4v-4.41l-3-3ZM8,6h8v2H8v-2Zm-4,14c-1.1,0-2-.9-2-2v-3.59l1-1v4.59h3c0,1.1-.9,2-2,2Zm10,0c0,1.1-.9,2-2,2s-2-.9-2-2v-4.59l2-2,2,2v4.59Zm-2-9.41l-4,4v1.41h-3v-6h14v6h-3v-1.41l-4-4Zm10,7.41c0,1.1-.9,2-2,2s-2-.9-2-2h3v-4.59l1,1v3.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgyDth);
export default __webpack_public_path__ + "static/media/SGY-DTH.5c2af5272cedd2109f8d6f6f0a6119ec.svg";
export { ForwardRef as ReactComponent };